import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { promoteEntity } from '../services/intelligenceApi';
import EntityPivotLink from './EntityPivotLink';

function PromoteModal({
  open,
  onClose,
  onPromoted,
  sourceType,
  sourceId,
  sourceLabel,
  defaultPromoteType = 'search_to_indicator',
  extractedItem = null,
}) {
  const [cases, setCases] = useState([]);
  const [caseId, setCaseId] = useState('');
  const [confidence, setConfidence] = useState('medium');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    setError('');
    api.get('/hdp/cases').then((res) => {
      setCases(res.data.cases || []);
    }).catch(() => setCases([]));
  }, [open]);

  if (!open) return null;

  const submit = async () => {
    setSubmitting(true);
    setError('');
    try {
      let payload;
      if (extractedItem) {
        payload = {
          promote_type: 'extracted_indicator',
          ioc_type: extractedItem.ioc_type,
          value: extractedItem.value,
          case_id: caseId || undefined,
          search_id: sourceType === 'search' ? sourceId : undefined,
          confidence,
        };
      } else {
        payload = {
          promote_type: 'search_to_indicator',
          search_id: sourceId,
          case_id: caseId || undefined,
          confidence,
        };
      }
      const res = await promoteEntity(payload);
      onPromoted?.(res.data.indicator);
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Promotion failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose} role="presentation">
      <div className="modal-card" onClick={(e) => e.stopPropagation()} role="dialog">
        <h2 className="modal-title">Promote to investigation</h2>
        <p className="modal-subtitle">
          Source: <EntityPivotLink type={sourceType} id={sourceId} label={sourceLabel} showBadge />
        </p>

        <div className="form-group">
          <label className="form-label">Create as</label>
          <div className="modal-radio">Indicator linked to platform registry</div>
        </div>

        <div className="form-group">
          <label className="form-label">Add to case</label>
          <select className="form-input" value={caseId} onChange={(e) => setCaseId(e.target.value)}>
            <option value="">No case (standalone indicator)</option>
            {cases.map((item) => (
              <option key={item.case_id} value={item.case_id}>
                {item.case_number} · {item.title}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Confidence</label>
          <select className="form-input" value={confidence} onChange={(e) => setConfidence(e.target.value)}>
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
          </select>
        </div>

        {error && <div className="hdp-alert error">{error}</div>}

        <div className="modal-actions">
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button type="button" className="btn btn-primary" disabled={submitting} onClick={submit}>
            {submitting ? 'Promoting...' : 'Promote'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PromoteModal;
